
















































































































































import {
  defineComponent,
  reactive,
  SetupContext,
  Ref,
} from '@vue/composition-api'

import { MultiUserState } from '@/types/store'
import { IUser, UserRole } from '@/types/user'

import useVuex from '@/utils/useVuex'

import { AppInput, AppAutocomplete } from '@/components/atoms'
import moment from 'moment'

type Props = {}

export default defineComponent({
  name: 'UserDetail',
  components: {
    AppInput,
    AppAutocomplete,
  },
  props: {},
  setup(props: Props, context: SetupContext) {
    const store = context.root.$store

    const state = reactive<{
      multiUser: Ref<IUser>
    }>({
      multiUser: useVuex<MultiUserState['multiUser']>(
        context,
        () => store.getters['multiUser/multiUser'],
      ),
    })

    const onChangeCode = (code: string) => {
      state.multiUser = {
        ...state.multiUser,
        code,
      }
    }

    const onChangeCastId = (castId: string) => {
      state.multiUser = {
        ...state.multiUser,
        castId,
      }
    }

    const onChangeCastName = (castName: string) => {
      state.multiUser = {
        ...state.multiUser,
        castName,
      }
    }

    const onChangeMail = (mail: string) => {
      state.multiUser = {
        ...state.multiUser,
        mail,
      }
    }

    const onChangePassword = (password: string) => {
      state.multiUser = {
        ...state.multiUser,
        password,
      }
    }

    const onSelectRoleInfo = (role: UserRole) => {
      state.multiUser = {
        ...state.multiUser,
        role,
      }
    }

    const roleList: Record<string, string>[] = Object.entries(UserRole)
      .filter(u => u[1] !== UserRole.ANY)
      .map(([key, value]) => {
        return { key, value }
      })

    const save = async () => {
      if (state.multiUser.id < 0) {
        await store.dispatch('multiUser/createMultiUser', state.multiUser)
        context.root.$router.go(-1)
        return
      }
      const error = await store.dispatch(
        'multiUser/updateMultiUser',
        state.multiUser,
      )
      if (error) {
        console.error(error)
      } else {
        context.root.$router.go(-1)
      }
    }

    const remove = async () => {
      if (confirm('この処理は元に戻すことができません。本当に実行しますか？')) {
        await store.dispatch('multiUser/deleteMultiUser', state.multiUser.id)
        context.root.$router.go(-1)
      }
    }

    const goBack = () => {
      context.root.$router.go(-1)
    }

    const formatForDisplay = (date: Date): string => {
      return moment(date).format('YYYY/MM/DD HH:mm:ss')
    }

    return {
      state,
      roleList,
      onChangeCode,
      onChangeCastId,
      onChangeCastName,
      onChangeMail,
      onChangePassword,
      onSelectRoleInfo,
      save,
      remove,
      goBack,
      formatForDisplay,
    }
  },
})
